(() => {
  const script = document.querySelector('script[data-fm-image-map]');
  const main = document.getElementById('MainContent');
  if (!script || !main) return;
  fetch(script.dataset.fmImageMap).then(r => { if (!r.ok) throw new Error('images'); return r.json(); }).then(mapping => {
    const pending = new Set();
    let frame = 0;
    const update = img => {
      const source = img.getAttribute('src') || img.getAttribute('data-src');
      if (!source || source.startsWith('data:')) return;
      let filename;
      try { filename = decodeURIComponent(new URL(source, location.origin).pathname.split('/').pop()).replace(/_\d+x\d*(?=\.[^.]+$)/, ''); } catch { return; }
      const target = mapping[filename];
      const neutral = (target || source).includes('filamelt-compact-series-neutral');
      if (neutral) {
        const info = img.closest('.spf-product-card, .card-wrapper')?.querySelector('.spf-product__info, .card__information');
        if (info && !info.querySelector('.fm-series-image-note')) {
          const note = document.createElement('p'); note.className = 'fm-series-image-note';
          note.textContent = script.dataset.fmSeriesNote; info.appendChild(note);
        }
      }
      if (!target) return;
      const imageUrl = width => { const url = new URL(target, location.origin); url.searchParams.set('width', width); return url.href; };
      const srcset = [240,320,480,640,960,1280,1600].map(width => `${imageUrl(width)} ${width}w`).join(', ');
      const card = img.closest('.spf-product-card, .card-wrapper');
      if (!img.getAttribute('sizes') && card) img.setAttribute('sizes', '(min-width: 990px) 25vw, 50vw');
      if (img.getAttribute('srcset') !== srcset) img.setAttribute('srcset', srcset);
      const fallback = imageUrl(640);
      if (img.getAttribute('src') !== fallback) img.setAttribute('src', fallback);
      if (img.hasAttribute('data-srcset')) img.setAttribute('data-srcset', srcset);
      if (img.hasAttribute('data-src')) img.setAttribute('data-src', imageUrl('{width}').replace('%7Bwidth%7D', '{width}'));
      img.width = 1600; img.height = 1600;
      if (img.classList.contains('spf-product-card__image-main')) img.closest('.spf-product-card')?.classList.add('fm-card-cutout');
    };
    const queue = img => {
      pending.add(img);
      if (!frame) frame = requestAnimationFrame(() => {
        frame = 0;
        for (const image of pending) if (image.isConnected) update(image);
        pending.clear();
      });
    };
    new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'attributes' && record.target instanceof HTMLImageElement) queue(record.target);
        for (const node of record.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (node instanceof HTMLImageElement) queue(node);
          node.querySelectorAll('img').forEach(queue);
        }
      }
    }).observe(main, {subtree:true, childList:true, attributes:true, attributeFilter:['src','srcset']});
    main.querySelectorAll('img').forEach(queue);
  }).catch(() => {});
})();
